export default __webpack_public_path__ + "static/media/logi_3-min.b278de27.JPG";